import SubscriptionData from "./SubscriptionData";

export default SubscriptionData;
